const topFirst = () => {
  if (document.querySelector("body#pageTop") !== null) {



    let sW = window.innerWidth;

    var secFirst = document.querySelector('#jsSecFirst');


    var textWrapper = secFirst.querySelector('.text_04');
    textWrapper.innerHTML = textWrapper.textContent.replace(/\S/g, "<span class='letter'>$&</span>");

    anime.timeline({})
      .add({
        targets: '#jsSecFirst .text_04 .letter',
        translateX: [20, 0],
        translateZ: 0,
        opacity: [0, 1],
        easing: "easeOutExpo",
        duration: 1200,
        delay: (el, i) => 500 + 30 * i
      }).add({
        targets: '#jsSecFirst .text_04',
        opacity: 0,
        duration: 1000,
        easing: "easeOutExpo",
        delay: 1000
      });



    gsap.to('#jsSecFirst .first-wrap', {
      opacity: 0,
      transform: 'scale(0.95)',
      duration: 1,
      ease: "power1.inOut",
    }, 2)

    gsap.to(secFirst, {
      opacity: 0,
      display: 'none',
      duration: 1,
      ease: "power1.inOut",
    }, 3)



    let secBg = document.querySelector('#jsComSecBg');
    let video
    if (sW > 768) {
      video = document.querySelector('.js-video-pc');
    } else {
      video = document.querySelector('.js-video-sp');
    }

    video.load()

    setTimeout(() => {
      video.play()
    }, 3600);



  }
}
export default topFirst;